import { render, staticRenderFns } from "./PDFListPage.vue?vue&type=template&id=5bc6de72&scoped=true&"
import script from "./PDFListPage.vue?vue&type=script&lang=js&"
export * from "./PDFListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6de72",
  null
  
)

export default component.exports